module.exports = __webpack_public_path__ + "img/copy.6f358d7e.svg";